/**
 * El interruptor de la barra superior que muestra u oculta los montos sensibles
 * de todas las pantallas a la vez (plan del portal, D5). Va junto al perfil.
 *
 * Es un botón con `aria-pressed`: el estado que anuncia es «montos visibles».
 */
import { Eye, EyeOff } from 'lucide-react'
import { useMontosStore } from '@/store/montosStore'

export function InterruptorMontos({ compacto = false }: { compacto?: boolean }) {
  const { visibles, alternar } = useMontosStore()
  const rotulo = visibles ? 'Ocultar montos' : 'Mostrar montos'
  return (
    <button
      type="button"
      onClick={alternar}
      aria-pressed={visibles}
      aria-label={rotulo}
      title={rotulo}
      className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-divider bg-surface text-xs font-semibold text-content-muted hover:text-content hover:bg-soft transition-colors"
    >
      {visibles
        ? <Eye size={16} className="text-primary" aria-hidden="true" />
        : <EyeOff size={16} aria-hidden="true" />}
      {!compacto && <span className="hidden sm:inline">{visibles ? 'Montos visibles' : 'Montos ocultos'}</span>}
    </button>
  )
}
